import { localStorage } from 'dibs-browser-storage';
import get from 'lodash.get';

import { PAGE_TYPE } from '../../../utils/pageConstants';
import isPageType from '../../../utils/isPageType';
import { PRIVACY_POLICY_CHANGE_LOCAL_STORAGE_KEY } from './privacyPolicyConstants';

const isAllowedPageType = () => !isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.CHECKOUT_CONFIRMATION]);

const hasSeenPrivacyPolicyChangeNotice = () =>
    localStorage.getItem(PRIVACY_POLICY_CHANGE_LOCAL_STORAGE_KEY);

export const initialRule = userId =>
    !!userId && isAllowedPageType() && !hasSeenPrivacyPolicyChangeNotice();

export const viewerRule = viewer => {
    if (!viewer) {
        return false;
    }

    const userCreatedDate = get(viewer, 'user.createdDate');
    const userWasCreatedBeforePolicyChange =
        userCreatedDate && new Date(userCreatedDate) < new Date('1/30/19');
    const isUS = get(viewer, 'regionalInfo[0].countryCode') === 'US';

    return !viewer.doNotShowPrivacyPolicyAlerts && userWasCreatedBeforePolicyChange && isUS;
};
